import { render } from "./InstagramIcon.vue?vue&type=template&id=c5b818e4&scoped=true"
import script from "./InstagramIcon.vue?vue&type=script&lang=js"
export * from "./InstagramIcon.vue?vue&type=script&lang=js"

import "./InstagramIcon.vue?vue&type=style&index=0&id=c5b818e4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2677690992/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b818e4"]])

export default __exports__